import {
  plotAndBuildingFields,
  floorUnitFieldsVacant,
  floorUnitFieldsPreRented,
  amenitiesVastuFields,
  legalDocFieldsVacant,
  legalDocFieldsPreRented,
  mediaFields,
  occupancyStatusOptions,
} from "../sharedOptions"
import type { CategorySection } from "../types"

export const builderFloorSections: Record<string, CategorySection[]> = {
  "Builder Floor (Vacant)": [
    { sectionTitle: "2. Plot & Building Details", fields: plotAndBuildingFields },
    { sectionTitle: "3. Floor & Unit Details", fields: floorUnitFieldsVacant },
    { sectionTitle: "4. Amenities & Vastu", fields: amenitiesVastuFields },
    {
      sectionTitle: "5. Financial Details",
      fields: [
        { key: "occupancyStatus", type: "dropdown", label: "Occupancy Status", options: [{ value: "Vacant", label: "Vacant" }], placeholder: "Vacant", tooltip: "Defaulted to Vacant for this listing." },
        { key: "totalSalePrice", type: "number", label: "Total Price", placeholder: "e.g. 5000000", tooltip: "Enter the total expected sale price for the property. This is your listing price." },
        { key: "pricePerSqFt", type: "number", label: "Price Per Sq. Ft. [Auto-Calculated]", placeholder: "e.g. 12000", tooltip: "System will calculate this. Formula: (Total Price / Super Built-up Area or Carpet Area)." },
        { key: "propertyTaxMunicipalTax", type: "number", label: "Property Tax / Municipal Tax", placeholder: "e.g. 50000", tooltip: "Mention the annual property tax paid to the local municipal authority." },
        { key: "monthlyMaintenanceCharges", type: "number", label: "Monthly Maintenance Charges", placeholder: "e.g. 5000", tooltip: "Enter the monthly maintenance charges for the property." },
      ],
    },
    { sectionTitle: "6. Legal & Documentation", fields: legalDocFieldsVacant },
    { sectionTitle: "7. Media", fields: mediaFields },
  ],
  "Builder Floor (Pre-Rented)": [
    { sectionTitle: "Plot & Building Details", fields: plotAndBuildingFields },
    { sectionTitle: "Floor & Unit Details", fields: floorUnitFieldsPreRented },
    { sectionTitle: "Amenities & Vastu", fields: amenitiesVastuFields },
    {
      sectionTitle: "Tenancy & Investment Details",
      fields: [
        { key: "occupancyStatus", type: "dropdown", label: "Occupancy Status", options: occupancyStatusOptions, placeholder: "Leased / Pre-Rented", tooltip: "Defaulted to Leased / Pre-Rented." },
        { key: "tenantProfile", type: "textarea", label: "Tenant Profile", placeholder: "" },
        { key: "currentMonthlyRental", type: "number", label: "Current Monthly Rental", placeholder: "" },
        { key: "leaseStartEndDate", type: "text", label: "Lease Start & End Date", placeholder: "" },
        { key: "securityDepositHeld", type: "number", label: "Security Deposit Held", placeholder: "" },
        { key: "totalSalePrice", type: "number", label: "Total Sale Price", placeholder: "" },
        { key: "rentalYieldPercent", type: "number", label: "Rental Yield (%) [Auto-Calculated]", placeholder: "" },
      ],
    },
    { sectionTitle: "Legal & Documentation", fields: legalDocFieldsPreRented },
    { sectionTitle: "Media", fields: mediaFields },
  ],
}
